<template>
  <div class="mine">
    <van-cell-group>
      <van-cell value="" label-class="lable-calsss" :label="deptName">
        <template #title>
          <h2 style="padding:10px 0 5px">{{ user.nickName }}</h2>
          <p style="padding:10px 0 5px">{{ user.userName }}</p>
        </template>
        <template #icon>
          <van-image
            width="72"
            height="72"
            :src="user.avatar"
          >
            <template #error>
              <div class="custom-error">{{ user.nickName }}</div>
            </template>
          </van-image>
        </template>
      </van-cell>
      <van-cell title="修改密码" value="" is-link icon="edit"  @click="show=true" />
      <van-cell title="注销" value="" is-link icon="exchange" @click="exitLog" />
      <mobile-divider />
    </van-cell-group>
    <van-dialog v-model="show" title="修改密码" :before-close="beforeClose"
                @confirm="handleConfirm"
                show-cancel-button>
      <van-form ref="myform">
        <!-- 输入密码 -->
        <van-field v-model="formmm.oldPassword"
                   type="password"
                   label="旧密码"
                   placeholder="请输入旧密码"
                   :rules="[
            { required: true, message: '请输入旧密码' }
          ]"
        />
        <van-field v-model="formmm.newPassword"
                   type="password"
                   label="新密码"
                   placeholder="请输入新密码"
                   :rules="[
            { required: true, message: '请输入新密码' }
          ]"
        />
        <van-field v-model="formmm.confirmPassword"
                   type="password"
                   label="新密码确认"
                   placeholder="请再次输入新密码"
                   :rules="[
            { required: true, message: '请输入新密码' }
          ]"
        />
        <van-row>
          <van-col span="24">
            <span style="color: red;font-size: 14px;padding: 5px 5px 5px 5px">{{pwdesc}}</span>
          </van-col>
        </van-row>
      </van-form>
    </van-dialog>

  </div>
</template>

<script>
import {Dialog, Notify} from 'vant'
import mndlindex from '../Mine/mndlindex.vue'
import QRCode from 'qrcodejs2'
import wx from 'weixin-js-sdk'

const _this = wx
export default {
  components: { mndlindex },
  data () {
    return {
      downloadapi: this.$global.downloadapi,
      txpathjm: null,
      deptName: '',
      user: [],
      Identity: 2,
      imgpicurl: require('../../assets/img/male.png'),
      malepng: require('../../assets/img/male.png'),
      femalepng: require('../../assets/img/female_1.png'),
      show: false,
      // pattern:/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,18}/,
      formmm: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null
      },
      loading: false,
      pwdesc: null,
      // 设置
      showset: false,
      pushTypes: [],
      settings: [],
      scanvalue: '',
      // 判断是微信还是app,0是微信1是app,默认app
      isapporwx: 1,

      showscan: false,

      showmndlbut: false,
      mnxsqx: false,
      mnjsqx: false,
      showmndl: false,
      yaccount: null,
      dlwz: '位置',
      // 用于老版本微信地址替换
      wxdomain: '',
      showjz: false
    }
  },
  created () {
    // 获取用户信息
    let zhat = this
    this.user = this.$store.getters.user
    this.deptName = this.user.dept && this.user.dept.deptName
    // this.$ajax.get('/appapi/getInfo').then(function (res) {
    //   if (res.code == 200) {
    //     zhat.user = res.user

    //     console.log(res.user)
    //   }
    // })
  },
  methods: {
    handleConfirm () {
      if (this.formmm.newPassword != this.formmm.confirmPassword) {
        Notify({type: 'danger', message: '两次输入的新密码不一致！'})
        return
      }

      let oldPassword = this.formmm.oldPassword
      let newPassword = this.formmm.newPassword

      const data = {
        oldPassword,
        newPassword
      }
      let zhat = this
      this.$refs['myform']
        .validate()
        .then(() => {
          this.$ajax.post('/appapi/UpPasswd', data).then(response => {
            console.log('消息提醒', response)
            if (response.code == 200) {
              zhat.show = false // 在这里手动的关闭弹窗
              Notify({type: 'success', message: '修改成功'})
              // 重置表单
              zhat.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null
              }
            } else {
              zhat.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null
              }
              Notify({type: 'danger', message: response.msg})
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    beforeClose (action, done) {
      if (action === 'confirm') {
        return done(false)
      } else {
        // 重置表单
        this.formmm = {
          oldPassword: null,
          newPassword: null,
          confirmPassword: null
        }
        return done()
      }
    },
    exitLog () {
      let that = this
      Dialog.confirm({
        message: '<span style="color:red;font-size:13px;">确认注销？</span>'
      })
        .then(() => {
          this.$ajax.get('/wxlogout').then((res) => {
            if (res.code == 200) {
              localStorage.clear()
              localStorage.removeItem('Token')
              that.$store.dispatch('setToken', '')
              location.href = '/login?cancellation=1'
            }
          })
        }
        )
        .catch(() => {
          // on cancel
        })
    }

  }
}
</script>
<style lang="less" scoped>
  .mine{
    /deep/.van-image{
      margin-right: 20px;
      .van-image__img{
        border-radius: 8px;
      }
      .van-image__error{
        background-color: #1989fa;
        color: #fff;
        border-radius: 8px;
      }
    }
  }
  .qrcode{
    display: inline-block;
    img {
      width: 232px;
      height: 232px;
      background-color: #fff; //设置白色背景色
      padding: 6px; // 利用padding的特性，挤出白边
      box-sizing: border-box;
    }
  }
  .title-class1
  {
    font-weight:bold;
    max-width: 60px;
  }
  .value-class1
  {
    color: red;
  }
  .lable-calsss
  {
    width: 200px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Mine/index.vue